
export const labTools = [
    {
        name: "STT Real Time",
        url: "/sttrt"
    },
    {
        name: "GPT",
        url: "/gpt"
    },
    {
        name: "STT From File",
        url: "/sttf"
    },
    {
        name: "OCR PDF",
        url: "/ocrpdf"
    },
    {
        name: "Presentation Maker",
        url: "/presentation"
    },
]

export const text = {
    pageTitle: "HomePage"
}